import Vue from "vue";
import Vuex from "vuex";

import student from "./store/student";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    student: student
  },
  mutations: {
    setStudentSwitchState(state, status) {
      state.student.studentId = {
        action: status.action,
        payload: status.payload
      };
    }
  },
  actions: {}
});
